export default __webpack_public_path__ + "static/media/rentals.f5901db8.svg";